<div class="main_content">
    <app-breadcrumb></app-breadcrumb>

    <div #page_section class="page_main_sec">


        <div class="row form-control-sec DAO_datacss">
            <div class="grid_panel">
                <div class="form-container">

                    <div class="row ">
                        <div class="col-lg-3">
                            <mat-form-field appearance="legacy" [style.width.%]="100">
                                <mat-label>Role Selection <span class="field-mandatory">*</span></mat-label>
                                <mat-select [(ngModel)]="selectedRole" (selectionChange)="onSelectRole($event.value)" (click)="searchText_RoleType.focus()" (focus)="searchText_RoleType.focus()" (closed)="searchText_RoleType.value=''">
                                    <input type="search" (keydown)="$event.stopPropagation()" #searchText_RoleType autocomplete="off" class="mat-select-search" placeholder="Select Role">
                                    <mat-option [value]="option" *ngFor="let option of lstRole| listFilter:{'name':searchText_RoleType.value}">
                                        {{option.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-4">
                            <mat-form-field appearance="legacy" [style.width.%]="100">
                                <mat-label>Select Inactive User<span class="field-mandatory">*</span></mat-label>

                                <mat-select [(ngModel)]="selected_inactiveuser" (selectionChange)="Select_Inactiveuser($event.value)" (click)="searchText_Inactiveuser.focus()" (focus)="searchText_Inactiveuser.focus()" (closed)="searchText_Inactiveuser.value=''">
                                    <input type="search" (keydown)="$event.stopPropagation()" #searchText_Inactiveuser autocomplete="off" class="mat-select-search" placeholder="Select user">
                                    <mat-option [value]="option" *ngFor="let option of inactive_Userlist| listFilter:{'name':searchText_Inactiveuser.value}">
                                        {{option.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg-3">
                            <mat-form-field appearance="legacy" [style.width.%]="100">
                                <mat-label>Process <span class="field-mandatory">*</span></mat-label>
                                <mat-select [(ngModel)]="selectedProcess" (selectionChange)="onSelectProcess($event.value)" (click)="searchText_ProcessType.focus()" (focus)="searchText_ProcessType.focus()" (closed)="searchText_ProcessType.value=''">
                                    <input type="search" (keydown)="$event.stopPropagation()" #searchText_ProcessType autocomplete="off" class="mat-select-search" placeholder="Select Process">
                                    <mat-option [value]="option" *ngFor="let option of lstProcess| listFilter:{'name':searchText_ProcessType.value}">
                                        {{option.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div> -->

                        <div class="col-lg-2 btnclscss ">
                            <button class="btncss mr-2 mb-2 btn_primary btn_thin " (click)="search() ">Search</button>
                        </div>
                    </div>
                    <div class="grid_panel " *ngIf="length>0">
                        <app-basic-gridview [lstData]="lstData" [columnsToHide]="columnsToHide" gridTitle="URN Pending List" [showExcelDownloadOption]="true" [showSearchOption]="true" [showRecordsPerPageOption]="true" [showPagination]="true" (cellClickEvent)="onGridCellClick($event)"
                            (selectallClickEvent)="selectallClick($event)" [columnsToExcludeFromExport]="[]" [hyperlinkCols]="hyperlinkCols">
                        </app-basic-gridview>
                    </div>



                </div>

            </div>

        </div>

        <div class="row form-control-sec DAO_datacss" *ngIf="length>0">
            <div class="grid_panel">
                <div class="form-container">


                    <div class="row ">
                        <div class="col-lg-6">
                            <mat-form-field [style.width.%]="100">
                                <mat-label>Re-assigned To Active </mat-label>
                                <mat-select [(ngModel)]="selected_user_active" (selectionChange)="onSelectActiveUser($event.value)" (click)="searchText_Activeuser.focus()" (focus)="searchText_Activeuser.focus()" (closed)="searchText_Activeuser.value=''">
                                    <input type="search" (keydown)="$event.stopPropagation()" #searchText_Activeuser autocomplete="off" class="mat-select-search" placeholder="Select user">
                                    <mat-option [value]="option" *ngFor="let option of Userlist_active| listFilter:{'name':searchText_Activeuser.value}">
                                        {{option.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-lg-2 btnclscss">
                            <button class="btncss mr-2 mb-2 btn_primary btn_thin" (click)="submit_request()">Update</button>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</div>